"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colourStyles = void 0;
var _chromaJs = _interopRequireDefault(require("chroma-js"));
const getColor = data => {
  return data.color || "#343a40";
};
const colourStyles = exports.colourStyles = {
  option: (styles, _ref) => {
    let {
      data
    } = _ref;
    return {
      ...styles,
      color: getColor(data)
    };
  },
  multiValue: (styles, _ref2) => {
    let {
      data
    } = _ref2;
    const color = (0, _chromaJs.default)(getColor(data));
    return {
      ...styles,
      backgroundColor: color.alpha(0.1).css()
    };
  }
};